



















































































	// @ts-ignore
    import _ from './MArticles.ts'; export default _;
